import { createAction } from 'redux-actions';

const changeRequestInProgress = createAction(
  'is-request-in-progress',
  isRequestInProgress => isRequestInProgress,
);
export default changeRequestInProgress;
